import { defineStore } from 'pinia'
import { isObject } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import dependencyStatus from '@/constants/dependencyStatus'
import { api, mock } from '@/services'

export const useWidgetPagesStore = defineStore('widget-pages', {
    state: () => ({
        widgetPageIdsByKey: {},
        widgetPages: {},
    }),
    actions: {
        async requestWidgetPage(url) {
            if (mock.mockingNews()) {
                return Promise.resolve({ data: mock.content()?.widget_page })
            }
            return api.get(url)
        },
        async fetchWidgetPage(url, id = null, keepContentWhileRefreshing = false, extra = {}) {
            id ??= uuidv4()
            this.widgetPages[id] = {
                id,
                url,
                status: dependencyStatus.pending,
                requested: new Date(),
                promise: null,
                error: null,
                data: keepContentWhileRefreshing
                    ? this.widgetPages[id]?.data
                    : null,
                extra,
            }

            this.widgetPages[id].promise = this.requestWidgetPage(url)
                .then((result) => {
                    if (!isObject(result.data)) {
                        throw new Error('Unexpected response data, expected an object')
                    }
                    this.widgetPages[id].status = dependencyStatus.fulfilled
                    this.widgetPages[id].data = result.data
                    return result
                })
                .catch((error) => {
                    this.widgetPages[id].status = dependencyStatus.rejected
                    this.widgetPages[id].error = error
                    this.widgetPages[id].data = null
                    throw error
                })

            return id
        },
        async refreshWidgetPage(id) {
            if (!this.widgetPages[id]) {
                throw new Error(`Widget page with id ${id} not found`)
            }

            // Fetch the widget page again
            await this.fetchWidgetPage(this.widgetPages[id].url, id, true)
            await this.widgetPages[id].promise
        },
        // TODO: Call this
        async clearWidgetPage(id) {
            const widgetPage = this.widgetPages[id]
            delete this.widgetPages[id]
            return widgetPage
        },
    },
})
